import { Fade } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { ReactElement, ReactNode} from 'react';
import Center from 'src/components/Center';
import DILogo from 'src/components/DILogo';
import FullPageError from 'src/components/FullPageError';
import Header from 'src/components/Header';
import useAuth from 'src/hooks/useAuth';
import LoadingIndicator from 'src/lib/components/LoadingIndicator';
import BaseLayout from 'src/routes/layouts/BaseLayout';

interface AppLayoutProps {
    children?: ReactNode;
    noSubHeader: boolean;
}

function OnboardingAppLayout({ children, noSubHeader }: AppLayoutProps): ReactElement {
    const { auth, error } = useAuth();

    if (!auth)
        return (
            <BaseLayout>
                <Center>
                    <Fade in={true} timeout={2500}>
                        <div>
                            <>
                                <DILogo lightVersion={false} size={512} />
                                {error ? (
                                    <FullPageError message="Authorization failed." />
                                ) : (
                                    <LoadingIndicator
                                        message="Authorizing..."
                                        loaderSize={100}
                                    />
                                )}
                            </>
                        </div>
                    </Fade>
                </Center>
            </BaseLayout>
        );

    return (
        
        <BaseLayout>
            <div>
                <nav style={{ position: 'relative' }}>
                    <Header />
                </nav>
                <article>{children}</article>
            </div>
        </BaseLayout>
    );
}

export default OnboardingAppLayout;
